<nav
  class="bg-white dark:bg-base-100 px-4 py-2 md:p-4 border-b border-gray-200 dark:border-gray-800"
>
  <div class="flex items-center justify-between">
    <button
      class="md:hidden dark:hidden p-0 bg-transparent hover:bg-transparent !h-fit border-0 w-32 shadow-none"
    >
      <img class="w-full" src="/assets/logo/qwikopay-text-dark.svg" alt="" />
    </button>
    <button
      class="dark:md:!hidden dark:flex p-0 bg-transparent hover:bg-transparent !h-fit border-0 w-32 shadow-none hidden"
    >
      <img class="w-full" src="/assets/logo/qwikopay-text-light.svg" alt="" />
    </button>
    <div class="hidden md:flex items-center justify-between">
      <button
        class="text-gray-600 dark:text-gray-300 hover:text-gray-900 hover:dark:text-white"
        (click)="toggleSideNav()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="size-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 6h16M4 12h16M4 18h16"
          />
        </svg>
      </button>
    </div>

    <div (click)="loadUserData()" class="drawer-content">
      <label
        for="user-preference"
        class="drawer-button btn rounded-full p-0 !h-10 !w-10 !min-h-10 !min-w-10"
      >
        @if (userImageLink()) {
          <img class="size-full rounded-full" [src]="userImageLink()" alt="" />
        } @else {
          <i class="fa-light fa-circle-user text-3xl"></i>
        }
      </label>
    </div>
  </div>
</nav>

<div
  class="drawer drawer-end z-[100]"
  *transloco="let t; prefix: 'user_profile'"
>
  <input id="user-preference" type="checkbox" class="drawer-toggle" />

  <div class="drawer-side">
    <label
      for="user-preference"
      aria-label="close sidebar"
      class="drawer-overlay"
      (click)="resetStates()"
    ></label>

    <div
      class="flex flex-col bg-white dark:bg-base-200 w-full md:w-96 text-base-content min-h-full py-2 px-4 transition-all duration-100 relative"
    >
      @if (isUserSettings()) {
        <div
          class="sticky-nav flex md:hidden justify-start items-center w-full !bg-white dark:!bg-base-200 py-2"
        >
          <label
            for="user-preference"
            class="drawer-button btn btn-sm bg-base-200 dark:bg-base-100 rounded-box"
            (click)="resetStates()"
          >
            <span class="flex items-center gap-1">
              <i class="fa-light text-xl fa-arrow-left"></i>
              <span class="text-base mt-1" *transloco="let t">{{
                t("back")
              }}</span>
            </span>
          </label>
        </div>
        <div
          class="sticky-nav hidden md:flex justify-end items-center w-full !bg-white dark:!bg-base-200 py-2"
        >
          <label
            for="user-preference"
            class="drawer-button btn btn-sm bg-base-200 dark:bg-base-100 rounded-box"
            (click)="resetStates()"
          >
            <span class="flex items-center gap-1">
              <span class="text-sm font-light mt-[0.1rem]">{{
                t("close")
              }}</span>
              <i class="fa-light text-base fa-xmark"></i>
            </span>
          </label>
        </div>

        <h3 class="text-2xl font-semibold mt-4 mb-2 px-2">
          {{ t("user_settings") }}
        </h3>

        <div
          class="flex flex-col gap-2 bg-base-200 dark:bg-base-100 rounded-box p-2 h-full"
        >
          <div class="collapse collapse-arrow bg-white dark:bg-base-200">
            <input [(ngModel)]="user_profile_collapse" type="checkbox" />
            <div class="collapse-title font-normal flex items-center text-base">
              <span>{{ t("user_profile_title") }}</span>
            </div>
            <div class="collapse-content bg-white dark:bg-base-200">
              <div class="flex justify-start items-center my-2 w-full">
                <button
                  [disabled]="loading()"
                  (click)="toggleEdit()"
                  class="btn btn-sm bg-base-200 dark:bg-base-100 rounded-box"
                >
                  @if (isEdit()) {
                    <span class="flex items-center gap-1">
                      <i class="fa-light text-sm fa-circle-xmark"></i>
                      <span class="mt-1">{{ t("cancel") }}</span>
                    </span>
                  } @else {
                    <span class="flex items-center gap-1">
                      <i class="fa-light text-sm fa-pen-to-square"></i>
                      <span class="mt-1">{{ t("edit_profile") }}</span>
                    </span>
                  }
                </button>
              </div>
              <div class="grid grid-cols-1 gap-2">
                <div
                  class="flex justify-center p-4 bg-neutral-100 dark:bg-base-100 rounded-box"
                >
                  <div class="avatarself-center">
                    <div
                      class="size-28 overflow-hidden rounded-full border-[8px] border-base-100 dark:border-base-200 relative"
                    >
                      @if (!isEdit() && userImage()) {
                        <img
                          class="absolute w-full h-full rounded-full object-cover"
                          [src]="userImageLink()"
                        />
                      } @else {
                        <qwiko-image-uploader
                          [updateItem]="true"
                          [currentFile]="userImageLink()"
                          [currentFile]="userImage()?.id ?? null"
                          [contextCollection]="'user'"
                          [contextFieldName]="'user_image'"
                          [contextID]="user()?.id || null"
                          (file)="userImage.set($event)"
                          [disabled]="!isEdit()"
                          [directusClient]="accountsAppInstance"
                        ></qwiko-image-uploader>
                      }
                    </div>
                  </div>
                </div>
                <label
                  class="form-control w-full rounded-box p-2 bg-neutral-100 dark:bg-base-100"
                >
                  <div class="label">
                    <span class="label-text-alt">{{ t("first_name") }}</span>
                  </div>
                  <input
                    [disabled]="!isEdit() || loading()"
                    name="first_name"
                    #first_name="ngModel"
                    [(ngModel)]="firstName"
                    type="text"
                    placeholder="{{ t('first_name_placeholder') }}"
                    class="input input-bordered w-full rounded-box dark:!text-neutral-content !text-neutral-800"
                  />
                </label>
                <label
                  class="form-control w-full rounded-box p-2 bg-neutral-100 dark:bg-base-100"
                >
                  <div class="label">
                    <span class="label-text-alt">{{ t("last_name") }}</span>
                  </div>
                  <input
                    [disabled]="!isEdit() || loading()"
                    name="last_name"
                    #last_name="ngModel"
                    [(ngModel)]="lastName"
                    type="text"
                    placeholder="{{ t('last_name_placeholder') }}"
                    class="input input-bordered w-full rounded-box dark:!text-neutral-content !text-neutral-800"
                  />
                </label>
                <label
                  class="form-control w-full rounded-box p-2 bg-neutral-100 dark:bg-base-100"
                >
                  <div class="label">
                    <span class="label-text-alt">{{ t("email") }}</span>
                  </div>
                  <input
                    [disabled]="true"
                    name="user_email"
                    #user_email="ngModel"
                    [(ngModel)]="email"
                    type="email"
                    placeholder="{{ t('email_placeholder') }}"
                    class="input input-bordered w-full rounded-box dark:!text-neutral-content !text-neutral-800"
                  />
                </label>
                <button
                  [disabled]="loading()"
                  *ngIf="isEdit()"
                  (click)="updateUserProfile()"
                  class="btn btn-success btn-md rounded-box w-full"
                >
                  @if (loading()) {
                    <span class="loading loading-spinner"></span>
                  } @else {
                    <span class="flex items-center text-white gap-1">
                      <i class="fa-light text-lg fa-circle-check"></i>
                      <span class="text-lg mt-1" *transloco="let t">{{
                        t("save")
                      }}</span>
                    </span>
                  }
                </button>
              </div>
            </div>
          </div>

          <button
            class="flex justify-between bg-white dark:bg-base-200 p-4 swap swap-rotate rounded-box w-full"
            (click)="toggleTheme()"
            [disabled]="loading()"
          >
            <span class="flex items-center gap-2">
              <span>
                {{ t("change_theme") }}
              </span>
              <span *ngIf="currentTheme() == 'dark'">({{ t("dark") }})</span>
              <span *ngIf="currentTheme() == 'light'">({{ t("light") }})</span>
            </span>
            <input hidden type="checkbox" />

            @if (loading() && loadingTarget() === "theme") {
              <span class="loading loading-spinner"></span>
            } @else {
              <svg
                class="size-6 fill-current sun"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                *ngIf="currentTheme() == 'dark'"
              >
                <path
                  d="M5.64,17l-.71.71a1,1,0,0,0,0,1.41,1,1,0,0,0,1.41,0l.71-.71A1,1,0,0,0,5.64,17ZM5,12a1,1,0,0,0-1-1H3a1,1,0,0,0,0,2H4A1,1,0,0,0,5,12Zm7-7a1,1,0,0,0,1-1V3a1,1,0,0,0-2,0V4A1,1,0,0,0,12,5ZM5.64,7.05a1,1,0,0,0,.7.29,1,1,0,0,0,.71-.29,1,1,0,0,0,0-1.41l-.71-.71A1,1,0,0,0,4.93,6.34Zm12,.29a1,1,0,0,0,.7-.29l.71-.71a1,1,0,1,0-1.41-1.41L17,5.64a1,1,0,0,0,0,1.41A1,1,0,0,0,17.66,7.34ZM21,11H20a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Zm-9,8a1,1,0,0,0-1,1v1a1,1,0,0,0,2,0V20A1,1,0,0,0,12,19ZM18.36,17A1,1,0,0,0,17,18.36l.71.71a1,1,0,0,0,1.41,0,1,1,0,0,0,0-1.41ZM12,6.5A5.5,5.5,0,1,0,17.5,12,5.51,5.51,0,0,0,12,6.5Zm0,9A3.5,3.5,0,1,1,15.5,12,3.5,3.5,0,0,1,12,15.5Z"
                />
              </svg>

              <svg
                class="size-6 fill-current moon"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                *ngIf="currentTheme() == 'light'"
              >
                <path
                  d="M21.64,13a1,1,0,0,0-1.05-.14,8.05,8.05,0,0,1-3.37.73A8.15,8.15,0,0,1,9.08,5.49a8.59,8.59,0,0,1,.25-2A1,1,0,0,0,8,2.36,10.14,10.14,0,1,0,22,14.05,1,1,0,0,0,21.64,13Zm-9.5,6.69A8.14,8.14,0,0,1,7.08,5.22v.27A10.15,10.15,0,0,0,17.22,15.63a9.79,9.79,0,0,0,2.1-.22A8.11,8.11,0,0,1,12.14,19.73Z"
                />
              </svg>
            }
          </button>

          <label
            class="form-control w-full flex flex-col gap-1 items-start bg-white dark:bg-base-200 p-4 rounded-box"
          >
            <div class="label">
              <span class="label-text-alt text-base">{{
                t("language_label")
              }}</span>
            </div>
            <select
              class="select select-bordered w-full rounded-box"
              [ngModel]="languageService.appLanguage() | json"
              (ngModelChange)="setLanguage($event)"
              [disabled]="loading()"
            >
              <option disabled selected>
                {{ t("language_placeholder") }}
              </option>
              @for (
                language of languageService.getFilteredLanguages();
                track $index;
                let count = $count
              ) {
                <option [value]="language | json">{{ language.name }}</option>
              }
            </select>
          </label>

          <!-- <button
            class="flex justify-between bg-white dark:bg-base-200 px-4 py-2 swap swap-rotate rounded-box w-full"
            (click)="toggleChangePassword()"
            [disabled]="loading()"
          >
            <span class="flex items-center gap-2">
              <span>
                {{ t("change_password") }}
              </span>
            </span>

            <i class="fa-light fa-chevron-right text-lg"></i>
          </button> -->
        </div>
      }
      <button
        type="button"
        class="btn btn-sm w-10/12 mx-auto btn-link text-orange-800 rounded-box"
        (click)="modalService.open('delete_account_modal')"
        [disabled]="loading()"
      >
        @if (loading() && loadingTarget() === "delete-account") {
          <span class="loading loading-spinner"></span>
        } @else {
          <span> {{ t("delete_account") }} </span>
        }
      </button>

      @if (isChangePassword()) {
        <div class="flex justify-between items-center mb-2 w-full">
          <button
            (click)="toggleChangePassword()"
            [disabled]="loading()"
            class="btn btn-sm bg-base-200 dark:bg-base-100 rounded-box"
          >
            <span class="flex items-center gap-1">
              <i class="fa-light text-xl fa-arrow-left"></i>
              <span class="text-base mt-1" *transloco="let t">{{
                t("back")
              }}</span>
            </span>
          </button>
          <button
            (click)="toggleChangePassword()"
            class="btn btn-sm bg-base-200 dark:bg-base-100 rounded-box"
          >
            <span class="flex items-center gap-1">
              <i class="fa-light text-xl fa-circle-check"></i>
              <span class="text-base mt-1" *transloco="let t">{{
                t("done")
              }}</span>
            </span>
          </button>
        </div>

        <h3 class="text-xl font-semibold mt-4 mb-2 px-2">
          {{ t("change_password") }}
        </h3>
        <qwiko-alert></qwiko-alert>
        <div class="grid grid-cols-1 gap-2">
          <form class="grid grid-cols-1 gap-2" #changePasswordForm="ngForm">
            <label
              class="form-control w-full rounded-box p-2 bg-neutral-100 dark:bg-base-100"
            >
              <div class="label">
                <span class="label-text-alt">{{ t("current_password") }}</span>
              </div>
              <input
                [disabled]="loading()"
                #password_old="ngModel"
                [(ngModel)]="passwordOld"
                type="password"
                name="old_password"
                required
                placeholder="{{ t('enter_current_password') }}"
                class="input input-bordered w-full rounded-box dark:!text-neutral-content !text-neutral-800"
                [ngClass]="
                  password_old.touched && password_old.invalid
                    ? 'input-error'
                    : ''
                "
              />
            </label>

            <label
              class="form-control w-full rounded-box p-2 bg-neutral-100 dark:bg-base-100"
            >
              <div class="label">
                <span class="label-text-alt">{{ t("new_password") }}</span>
              </div>
              <input
                [disabled]="loading()"
                #password_new="ngModel"
                [(ngModel)]="password"
                required
                name="password"
                type="password"
                pattern=".{8,}"
                placeholder="{{ t('enter_new_password') }}"
                class="input input-bordered w-full rounded-box dark:!text-neutral-content !text-neutral-800"
                [ngClass]="
                  password_new.touched &&
                  password_repeat.touched &&
                  password_new.value !== password_repeat.value
                    ? 'input-error'
                    : ''
                "
              />

              @if (password_new.touched && password_new.invalid) {
                <div class="label">
                  <span class="label-text-alt !text-error">
                    {{ t("password_length_error") }}</span
                  >
                </div>
              }

              @if (
                password_repeat.touched &&
                password_new.value != password_repeat.value
              ) {
                <div class="label">
                  <span class="label-text-alt !text-error">{{
                    t("password_match_error")
                  }}</span>
                </div>
              }
            </label>
            <label
              class="form-control w-full rounded-box p-2 bg-neutral-100 dark:bg-base-100"
            >
              <div class="label">
                <span class="label-text-alt">{{ t("repeat_password") }}</span>
              </div>
              <input
                [disabled]="loading()"
                #password_repeat="ngModel"
                [(ngModel)]="passwordRepeat"
                required
                name="password_repeat"
                type="password"
                placeholder="{{ t('enter_new_password') }}"
                class="input input-bordered w-full rounded-box dark:!text-neutral-content !text-neutral-800"
                [ngClass]="
                  password_new.touched &&
                  password_repeat.touched &&
                  password_new.value !== password_repeat.value
                    ? 'input-error'
                    : ''
                "
              />

              @if (
                password_repeat.touched &&
                password_new.value != password_repeat.value
              ) {
                <div class="label">
                  <span class="label-text-alt !text-error">{{
                    t("password_match_error")
                  }}</span>
                </div>
              }
            </label>
          </form>
          <button
            [disabled]="
              (password_new.valid === password_repeat.valid &&
                password_new.value != password_repeat.value) ||
              loading() ||
              changePasswordForm.invalid
            "
            (click)="changeUserPassword()"
            class="btn btn-success btn-md rounded-box w-full"
          >
            @if (loading()) {
              <span class="loading loading-spinner"></span>
            } @else {
              <span class="flex items-center text-white gap-1">
                <span class="text-lg mt-1" *transloco="let t">{{
                  t("change_password")
                }}</span>
              </span>
            }
          </button>
        </div>
      }

      <div
        *ngIf="!isChangePassword()"
        class="flex flex-col gap-2 rounded-box p-2 h-full mt-auto self-end"
      >
        <button
          class="flex justify-between btn btn-error btn-outline rounded-box w-full"
          (click)="signOut()"
          [disabled]="loading()"
        >
          <span class="flex items-center gap-2">
            <span *transloco="let t">
              {{ t("sign_out") }}
            </span>
          </span>

          @if (loading() && loadingTarget() === "signOut") {
            <span class="loading loading-spinner"></span>
          } @else {
            <i class="fa-solid fa-power-off text-lg"></i>
          }
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Delete Account Modal -->
<qwiko-modal
  [id]="'delete_account_modal'"
  [isCentered]="true"
  [isDismissible]="false"
  *transloco="let t; prefix: 'delete_account_modal'"
>
  <div
    class="max-w-md z-50 pt-2 pb-2 md:px-2 bg-white dark:bg-base-300 border-b border-b-base-200 shadow shadow-neutral-200 dark:shadow-neutral-800"
  >
    <div class="flex justify-end mb-2 w-full">
      <button
        type="button"
        class="btn btn-sm btn-ghost rounded-box"
        (click)="modalService.close('delete_account_modal')"
      >
        <span class="flex items-center gap-1">
          <i class="fa-light text-neutral-600 text-xl fa-xmark"></i>
        </span>
      </button>
    </div>
    <div class="w-full px-4 py-2 mx-auto">
      <span class="w-full flex justify-center items-center mx-auto mb-2">
        <i class="fa-light fa-exclamation-triangle text-error text-6xl"></i>
      </span>
      <h2 class="text-2xl font-semibold text-center w-full mb-3">
        {{ t("title") }}
      </h2>
      <h2 class="text-lg font-light text-center w-full mb-2">
        {{ t("subtitle") }}
      </h2>
    </div>
    <div class="mt-5 md:mt-10 card py-4 px-6 md:px-5 w-full">
      <button
        type="button"
        class="btn btn-md w-10/12 mx-auto btn-primary rounded-box"
        (click)="modalService.close('delete_account_modal')"
      >
        @if (loading()) {
          <span class="loading loading-spinner"></span>
        } @else {
          <span> {{ t("cancel") }} </span>
        }
      </button>
      <button
        type="button"
        class="btn btn-md w-10/12 mx-auto btn-link rounded-box"
        (click)="openSupport()"
      >
        @if (loading()) {
          <span class="loading loading-spinner"></span>
        } @else {
          <span> {{ t("contact_support") }} </span>
        }
      </button>
    </div>
  </div>

  <!-- <div
    class="w-full md:w-8/12 mx-auto max-h-[80vh] my-5 pb-10 px-6 md:px-5 overflow-y-auto"
  >
    <button
      type="button"
      class="btn btn-sm btn-ghost rounded-box w-full"
      (click)="modalService.close('install_modal')"
    >
      <span class="flex items-center gap-1">
        <i class="fa-light text-xl fa-xmark"></i>
        <span class="text-base mt-1">{{ t("click_to_close") }}</span>
      </span>
    </button>
  </div> -->

  <!-- <div
    class="fixed bottom-0 right-0 left-0 mt-5 md:mt-10 card py-4 px-6 md:px-5 rounded-b-none rounded-t-3xl w-full z-50 gap-y-2 bg-neutral-100 dark:bg-base-300 border-t border-t-neutral-200 dark:border-t-neutral-800 shadow dark:shadow-neutral-800"
  >
    <button
      type="button"
      class="btn btn-md w-full md:w-8/12 mx-auto btn-primary rounded-box"
      (click)="install()"
    >
      @if (loading()) {
        <span class="loading loading-spinner"></span>
      } @else {
        <span> {{ t("install") }} </span>
      }
    </button>
  </div> -->
</qwiko-modal>

<qwiko-edit-org-profile [loading]="loading()"></qwiko-edit-org-profile>
